/**
 * Added To Cart Popup App Component Exports
 *
 * @since 1.0.0
 */

export { AddedToCartPopupApp } from './component';
